import { OrderStatusEnum } from '@onArte/shared/enums/common/orders';
import { PromotionCodeInterface } from '@onArte/shared/interfaces/common/carts';
import { UserSimpleDTO } from '@onArte/shared/interfaces/common/users';

import { OrderAuctionDetailsDTO } from './orderAuctionDetails.dto';
import { OrderPaymentDetailsDTO } from './orderPaymentDetails.dto';

export class OrderBaseDetailsDTO {
  constructor(
    public id: string,
    public no: string,
    public buyer: UserSimpleDTO,
    public auctions: OrderAuctionDetailsDTO[],
    public promotionsCodes: PromotionCodeInterface[],
    public orderedAt: number,
    public status: OrderStatusEnum,
    public payment: OrderPaymentDetailsDTO,
    public commentToOrder: string | null,
  ) {}
}
